import React from 'react';
import { Tooltip } from 'antd';
import { LinkOutlined } from '@ant-design/icons';
import useRmReferralLink from '../../hooks/useRmReferralLink';

export default function RmReferralLinkButton() {
  const { hasReferralLink, referralLink, copyReferralLink } = useRmReferralLink();

  if (!hasReferralLink) return null;

  return (
    <Tooltip title={referralLink} placement="bottom">
      <button
        type="button"
        onClick={copyReferralLink}
        className="inline-flex items-center gap-2 rounded-xl border border-primary bg-white px-4 py-2.5 text-sm font-semibold text-primary transition-colors hover:bg-primary-muted active:scale-[0.99]"
      >
        <LinkOutlined aria-hidden />
        RM Referral Link
      </button>
    </Tooltip>
  );
}
